var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c("b-col", [
        _c(
          "div",
          { staticClass: "club-group" },
          _vm._l(Object.keys(_vm.quantities), function (quant) {
            return _c(
              "div",
              {
                key: quant,
                staticClass: "club-card",
                class: {
                  selected: _vm.selectedOrderQuantityComputed === quant,
                },
                on: {
                  click: function ($event) {
                    _vm.selectedOrderQuantityComputed = quant
                  },
                },
              },
              [
                _c("div", { staticClass: "club-card-inner" }, [
                  _c("div", { staticClass: "graphic" }, [
                    _c("div", {
                      staticClass: "image",
                      style: { backgroundImage: `url(${_vm.quantityImage})` },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "club-card-content" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.quantity(quant)))]),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }